export const styleObjectToString = (style: object) =>
    Object.entries(style)
        .map(([k, v]) => `${k}:${v}`)
        .join(';');
